<template>
  <div class='category-list'>
    <router-link class='cat-circle'
      v-for='cat in _categories'
      :style="{backgroundImage: 'url(' + cat.cover + ')'}"
      :key="cat.slug"
      :to="cat.slug">
      <div>{{ cat.name }}</div>
    </router-link>
  </div>
</template>

<script>
import {categoryData} from '@/categories'

export default {
  props: ['categories'],
  name: 'CategoryList',
  computed: {
    _categories: function () {
      return this.categories.map((cat) => {
        let cd = categoryData[cat]
        return {
          slug: cat,
          name: cd.name,
          cover: cd.cover
        }
      })
    }
  }
}
</script>
<style scoped>
.category-list {
  width: 30em;
  margin: auto;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
}
.category-list .cat-circle {
  clip-path: circle(64px at center);
  text-align: center;
  background-color: #f8dbdd;
  height: 8em;
  width: 8em;
  margin: 0.5em;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-size: cover;
  background-position: center;
}

.category-list .cat-circle div {
  background-color: #f8dbddcc;
  width: 100%;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/CategoryList.vue